import { render } from "./Informacao-Gerais.vue?vue&type=template&id=a145be64&scoped=true"
import script from "./Informacao-Gerais.vue?vue&type=script&lang=js"
export * from "./Informacao-Gerais.vue?vue&type=script&lang=js"

import "./Informacao-Gerais.vue?vue&type=style&index=0&id=a145be64&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a145be64"]])

export default __exports__